// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__39_X9","bigColWidth":"Table_bigColWidth__11yRt","biggerColWidth":"Table_biggerColWidth__n7Msu","row":"Table_row__w0hZF","col":"Table_col__AN4IF"};